export default __webpack_public_path__ + "static/speed-7e3fdf41f502f25306dc5ef9c18802d5.png";